<template>
    <div class="paginated-footer">
        <div class="d-sm-flex text-left">
            <p> Totale: {{ total }}</p>
            <nav class="ml-auto">
                <ul class="pagination justify-content-start">
                    <li class="page-item" :class="{'disabled': value._page == 1}">
                        <button class="page-link btn btn-sm" aria-label="back"
                            @click="value._page > 1 ? $emit('changePage', value._page - 1) : null">
                            <span aria-hidden="true">&laquo;</span>
                            <span class="sr-only">back</span>
                        </button>
                    </li>
                    <li class="page-item" v-if="typeof pagesToShow == 'object' && this.page > 3">...</li>
                    <li class="page-item" v-for="i in pagesToShow" :key="`page_${i}`"
                        :class="{'active': i == value._page}">
                        <button class="page-link btn btn-sm" @click="$emit('changePage', i)">{{i}}</button>
                    </li>
                    <li class="page-item" v-if="typeof pagesToShow == 'object' && this.page < this.pages - 2">...</li>
                    <li class="page-item" :class="{'disabled': pages == value._page}"
                        @click="value._page < pages ? $emit('changePage', value._page + 1) : null">
                        <button class="page-link btn btn-sm" aria-label="next">
                            <span aria-hidden="true">&raquo;</span>
                            <span class="sr-only">next</span>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaginatedFooter',
    props: {
        data: {
            type: Array,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        page () {
            return parseInt(this.value._page)
        },
        pages () {
            return Math.ceil(this.total / this.value._limit)
        },
        pagesToShow () {
            if (this.pages <= 10) {
                return this.pages
            }
            if (this.page < 3) {
                return [1, 2, 3, 4]
            } else if (this.page >= this.pages - 2) {
                return [
                    this.pages - 3,
                    this.pages - 2,
                    this.pages - 1,
                    this.pages
                ]
            } else {
                return [
                    this.page - 2,
                    this.page - 1,
                    this.page,
                    this.page + 1,
                    this.page + 2
                ]
            }
        }
    }
}
</script>
